export enum TenantType {
  RECEIVABLES = 'Receivables',
  SeparateBankAccounts = 'SeparateBankAccounts',
  CentralisedBanking = 'CentralisedBanking',
  HealthDistributions = 'HealthDistributions',
  SurgicalPartnersEnterprise = 'SurgicalPartnersEnterprise',
}
